import { z } from 'zod';
import { Money } from './money';

export const ReservationStatus = z.enum(['PLANNED', 'SEATED', 'CANCELLED', 'NO_SHOW']);
export type ReservationStatus = z.infer<typeof ReservationStatus>;

export const ReservationRow = z.object({
  id: z.string(),
  tableId: z.string(),
  tableName: z.string(),
  guestName: z.string(),
  phone: z.string().nullable(),
  guests: z.number().int(),
  startAt: z.string().datetime(),
  durationMin: z.number().int(),
  status: ReservationStatus,
  comment: z.string().nullable(),
  /** предоплата в тиынах; depositUsedAt — когда зачтена в чеке */
  deposit: Money,
  depositUsedAt: z.string().datetime().nullable(),
});
export type ReservationRow = z.infer<typeof ReservationRow>;

export const ReservationsResponse = z.object({ rows: z.array(ReservationRow) });
export type ReservationsResponse = z.infer<typeof ReservationsResponse>;

export const CreateReservation = z.object({
  locationId: z.string().optional(), // офис передаёт; касса — из токена
  tableId: z.string(),
  guestName: z.string().min(1).max(60),
  phone: z.string().max(20).optional(),
  guests: z.number().int().min(1).max(50).default(2),
  startAt: z.string().datetime(),
  durationMin: z.number().int().min(30).max(600).default(120),
  comment: z.string().max(200).optional(),
  deposit: Money.min(0).optional(),
});
export type CreateReservation = z.infer<typeof CreateReservation>;

export const PatchReservation = z.object({
  status: ReservationStatus.optional(),
  deposit: Money.min(0).optional(),
  /** переезд: гости остались, стол сменился */
  tableId: z.string().optional(),
}).refine((v) => v.status !== undefined || v.deposit !== undefined || v.tableId !== undefined,
  { message: 'empty patch' });
export type PatchReservation = z.infer<typeof PatchReservation>;
